import { TransactionStatus } from '../constants';

export const getTransactionStatus = (
  status: string,
  settlementStatus: string
) => {
  if (status === 'disabled') return TransactionStatus.DISABLED;
  if (status === 'success' && settlementStatus === '')
    return TransactionStatus.TO_SETTLE;
  if (status === 'success' && settlementStatus === 'settled')
    return TransactionStatus.SETTLED;
  if (status === 'processing' && settlementStatus === '')
    return TransactionStatus.PROCCESSING;
  return TransactionStatus.DEFAULT;
};

export const getStatusColors = (status: string) => {
  if (status === 'Processing') {
    return {
      textColor: '!text-blue1',
      bgColor: 'bg-blue'
    };
  }
  if (
    (typeof status === 'string' && status.includes('Paid Offline')) ||
    status === 'Paid via Cofee' ||
    status === 'Paid via CoFee Autodebit'
  ) {
    return {
      textColor: 'text-primary40',
      bgColor: 'bg-primary10'
    };
  }
  if (status === 'Pending') {
    return {
      textColor: 'text-cofeeOrange6',
      bgColor: 'bg-cofeeOrange2'
    };
  }
  return {
    textColor: '',
    bgColor: ''
  };
};

export const quickCollectStatusConfig = (
  status: TransactionStatus,
  statusLabel = ''
) => {
  const statusConfigMap: Record<
    TransactionStatus,
    { label: string; className: string }
  > = {
    [TransactionStatus.DISABLED]: {
      label: 'Disabled',
      className: 'bg-grey10 text-cofeeNeutral6'
    },
    [TransactionStatus.TO_SETTLE]: {
      label: 'Processing',
      className: 'bg-blue text-blue1'
    },
    [TransactionStatus.SETTLED]: {
      label: 'Paid',
      className: 'bg-primary10 text-primary40'
    },
    [TransactionStatus.PROCCESSING]: {
      label: 'Pending',
      className: 'bg-cofeeOrange2 text-cofeeOrange6'
    },
    [TransactionStatus.DEFAULT]: {
      label: statusLabel || 'Unknown',
      className: 'bg-cofeeGreyBlue3 text-cofeeNeutral8'
    }
  };

  return statusConfigMap[status] || statusConfigMap[TransactionStatus.DEFAULT];
};
